import * as ActionTypes from "../actions/actionTypes";
import initialState from "./initialState";

export default (state = initialState.sources, action) => {
  switch (action.type) {
    case ActionTypes.RECEIVE_SOURCES_SNAPSHOT:
      return {
        ...state,
        data: action.sources,
        endBefore: action.endBefore,
        startAfter: action.startAfter
      };
    default:
      return state;
  }
};
